/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs'; 
import { NursingCounterApi } from '../api/nursingcounter.api';
import { switchMap, map } from 'rxjs/operators';
import { NursingCounterData, NursingCounter } from '../../../interfaces/masters/nursingcounter';

@Injectable()
export class NursingCounterService extends NursingCounterData {

  constructor(private api: NursingCounterApi) {
    super();
  }


  list(url: string): Observable<NursingCounter[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<NursingCounter>{
      return this.api.getById(url);
  }

  create(url: string, data:NursingCounter): Observable<NursingCounter[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:NursingCounter): Observable<NursingCounter> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
